<template>
    <img :class="rootClasses"
            :src="src"
            :srcset="srcSet"
            :alt="alt">
</template>
<script>
    import { srcsetFilter } from '@dreipol/vue-ui/src/filters';
    import bemMixin from '@dreipol/vue-ui/src/mixins/bem';
    import interactionObserverMixin from '@dreipol/vue-ui/src/mixins/intersection-observer';
    import bestPictureMixin from 'framework/mixins/best-picture';
    import { mapState } from 'vuex';
    import { IMAGES } from 'framework/vuex/modules/easter-egg/eggs';

    export default {
        components: {},
        mixins: [bestPictureMixin, interactionObserverMixin, bemMixin('picture-element')],
        props: {
            alt: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                isVisible: window.matchMedia('print').matches,
            };
        },
        computed: {
            ...mapState('easter-egg', {
                easterEggName: 'name',
            }),
            eggImage() {
                return IMAGES[this.easterEggName];
            },
            srcSet() {
                if (this.eggImage) {
                    return [this.eggImage];
                }
                return this.isVisible ? srcsetFilter(this.urls.default) : '';
            },
            src() {
                if (this.eggImage) {
                    return this.eggImage;
                }
                return this.isVisible ? this.urls.default[0] : this.urls.lazy[0];
            },
            rootClasses() {
                return [
                    this.bemRoot,
                    this.bemIf(this.isVisible, 'is-visible', 'is-blurry'),
                ];
            },
        },
        methods: {
            onIntersectEnter() {
                this.isVisible = true;
                this.kill();
            },
            kill() {
                this.unregister(this.$el);
            },
        },
        mounted() {
            this.registerObserver(this.$el, 0.1);
        },
        beforeDestroy() {
            this.kill();
        },
    };
</script>
